/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 24/05/22
 */

import { Workplan, WorkplanState, WorkplanVersion } from '@/wpt-lib/interfaces/Workplan';

export const isWorkplanReadonly = (
    workplan: Pick<Workplan, 'state'> | Pick<WorkplanVersion, 'state'>,
    isSupervisor?: boolean,
) => {
    if (isSupervisor) {
        return ![WorkplanState.SUBMITTED, WorkplanState.REVIEW, WorkplanState.MODERATION].includes(workplan.state);
    }

    return ![WorkplanState.DRAFT, WorkplanState.IN_PROGRESS, WorkplanState.INFORMATION_REQUESTED].includes(
        workplan.state,
    );
};

export const isWorkplanCompleted = (workplan: Workplan) => {
    return workplan.state === WorkplanState.ENDORSED;
};

export const isWorkplanInState = (workplan: Workplan | WorkplanVersion, ...states: WorkplanState[]) => {
    return states.includes(workplan.state);
};
